module.exports = __webpack_public_path__ + "img/background.e20ed155.png";